// FIXME This file need refactor and has technical depth

import { useState, useEffect } from "react";
import { Select } from "antd";
import { rangeGenerator } from "../../../../../base/utils";
import { API } from "../../../../../request/api";

// icons
import { ReactComponent as BottomArrow } from "../../../../../assets/svg/up-down-arrow.svg";
import IconCross from "../../../../../assets/images/icons/cross_rv.png";
import IconCar from "../../../../../assets/svg/car-service.svg";
import Button from "../../../../components/ui/Button";
import { useTranslation } from "react-i18next";
import { Note } from "../../../../../helbest";

const { Option } = Select;

const currentTime = new Date();
const grDates = rangeGenerator(currentTime.getFullYear(), 1980);

const SelectNewCar = (props) => {
  const {
    selectedUserCar,
    setSelectedUserCar,
    isAddingNewCar,
    selectedUserCarInfo,
    setSelectedUserCarInfo,
  } = props;
  //   console.log("🚀 ~ SelectNewCar ~ isAddingNewCar:", isAddingNewCar)
  // console.log("🚀 ~ SelectNewCar ~ selectedUserCarInfo:", selectedUserCarInfo);

  const { t } = useTranslation();

  const [types, set_types] = useState([
    {
      type_id: null,
      type_name: "",
    },
  ]);
  const [brands, set_brands] = useState([
    {
      brand_id: null,
      brand_name: "",
    },
  ]);
  const [models, set_models] = useState([
    {
      model_id: null,
      model_name: "",
    },
  ]);

  useEffect(() => {
    if (isAddingNewCar) {
      API.get
        .carsTypes()
        .then((response) => {
          if (response.success) {
            set_types(response.data);
          } else {
            Note.error(response.message);
          }
        })
        .catch((error) => {
          console.log("Error : ", error);
        });
    }
  }, [isAddingNewCar]);

  const handleSelectType = (value, option) => {
    if (isAddingNewCar) {
      setSelectedUserCar((prevState) => ({
        ...prevState,
        typeSelected: {
          type_id: value,
          type_name: option.children,
        },
      }));

      API.get
        .carsBrands(value)
        .then((response) => {
          if (response.success) {
            set_brands(response.data);
          } else {
            Note.error(response.message);
          }
        })
        .catch((error) => {
          console.log("Error : ", error);
        });
    } else {
      setSelectedUserCarInfo((prevState) => ({
        ...prevState,
        type_id: value,
        type_name: option.children,
      }));
    }
  };

  const handleSelectBrand = (value, option) => {
    if (isAddingNewCar) {
      setSelectedUserCar((prevState) => ({
        ...prevState,
        brandSelected: {
          brand_id: value,
          brand_name: option.children,
        },
      }));

      API.get
        .carsModels(value)
        .then((response) => {
          if (response.success) {
            set_models(response.data);
          } else {
            Note.error(response.message);
          }
        })
        .catch((error) => {
          console.log("Error : ", error);
        });
    } else {
      setSelectedUserCarInfo((prevState) => ({
        ...prevState,
        brand_id: value,
        brand_name: option.children,
      }));
    }
  };

  const handleSelectModel = (value, option) => {
    if (isAddingNewCar) {
      setSelectedUserCar((prevState) => ({
        ...prevState,
        modelSelected: {
          model_id: value,
          model_name: option.children,
        },
      }));
    } else {
      setSelectedUserCarInfo((prevState) => ({
        ...prevState,
        model_id: value,
        model_name: option.children,
      }));
    }
  };

  const handleSelectYear = (value) => {
    if (isAddingNewCar) {
      setSelectedUserCar((prevState) => ({
        ...prevState,
        yearSelected: value,
      }));
    } else {
      setSelectedUserCarInfo((prevState) => ({
        ...prevState,
        year: value,
      }));
    }
  };

  return (
    <div className="flex column">
      <div className="create_car_box flex column center">
        <div className="select_box col12">
          <Select
            dir="ltr"
            className="selectCarModalSelectBox"
            notFoundContent="no items found"
            bordered={false}
            placeholder={t("new_service.car_form.type")}
            defaultValue={t("new_service.car_form.type")}
            disabled={!isAddingNewCar}
            value={
              isAddingNewCar
                ? selectedUserCar?.typeSelected?.type_id
                  ? selectedUserCar?.typeSelected?.type_id
                  : t("new_service.car_form.type")
                : selectedUserCarInfo?.type_id
            }
            suffixIcon={<BottomArrow width={10} height={10} />}
            onChange={(value, option) => handleSelectType(value, option)}
          >
            {types.map((type) => (
              <Option
                className="dir-rtl"
                value={
                  isAddingNewCar ? type.type_id : selectedUserCarInfo?.type_id
                }
                key={
                  isAddingNewCar ? type.type_id : selectedUserCarInfo?.type_id
                }
              >
                {isAddingNewCar
                  ? type.type_name
                  : selectedUserCarInfo?.type_name}
              </Option>
            ))}
          </Select>
        </div>
        <div className="select_box col12">
          <Select
            dir="ltr"
            className="selectCarModalSelectBox"
            notFoundContent="no items found"
            bordered={false}
            placeholder={t("new_service.car_form.brand")}
            defaultValue={t("new_service.car_form.brand")}
            disabled={
              !selectedUserCar?.typeSelected?.type_id || !isAddingNewCar
            }
            suffixIcon={<BottomArrow width={10} height={10} />}
            value={
              isAddingNewCar
                ? selectedUserCar?.brandSelected?.brand_id
                  ? selectedUserCar?.brandSelected?.brand_id
                  : t("new_service.car_form.brand")
                : selectedUserCarInfo?.brand_id
            }
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value, option) => {
              handleSelectBrand(value, option);
            }}
          >
            {brands.length > 0 &&
              brands.map((brand) => {
                return (
                  <Option
                    className="dir-rtl"
                    value={
                      isAddingNewCar
                        ? brand.brand_id
                        : selectedUserCarInfo?.brand_id
                    }
                    key={
                      isAddingNewCar
                        ? brand.brand_id
                        : selectedUserCarInfo?.brand_id
                    }
                  >
                    {isAddingNewCar
                      ? brand.brand_name
                      : selectedUserCarInfo?.brand_name}
                  </Option>
                );
              })}
          </Select>
        </div>
        <div className="select_box col12">
          <Select
            dir="ltr"
            className="selectCarModalSelectBox"
            notFoundContent="no items found"
            bordered={false}
            disabled={
              !selectedUserCar?.brandSelected?.brand_id || !isAddingNewCar
            }
            suffixIcon={<BottomArrow width={10} height={10} />}
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            placeholder={t("new_service.car_form.model")}
            defaultValue={t("new_service.car_form.model")}
            value={
              isAddingNewCar
                ? selectedUserCar?.modelSelected?.model_id
                  ? selectedUserCar?.modelSelected?.model_id
                  : t("new_service.car_form.model")
                : selectedUserCarInfo?.model_id
            }
            onChange={(value, option) => {
              handleSelectModel(value, option);
            }}
          >
            {models.length > 0 &&
              models.map((model) => {
                return (
                  <Option
                    className="selectCarModalBoxOption"
                    value={
                      isAddingNewCar
                        ? model.model_id
                        : selectedUserCarInfo?.model_id
                    }
                    key={
                      isAddingNewCar
                        ? model.model_id
                        : selectedUserCarInfo?.model_id
                    }
                  >
                    {isAddingNewCar
                      ? model.model_name
                      : selectedUserCarInfo?.model_name}
                  </Option>
                );
              })}
          </Select>
        </div>
        <div className="select_box col12">
          <Select
            dir="ltr"
            className="selectCarModalSelectBox"
            notFoundContent="no items found"
            bordered={false}
            placeholder={t("new_service.car_form.year")}
            disabled={
              isAddingNewCar
                ? !selectedUserCar?.modelSelected?.model_id
                : !selectedUserCarInfo?.model_id
            }
            suffixIcon={<BottomArrow width={10} height={10} />}
            value={
              isAddingNewCar
                ? selectedUserCar?.yearSelected
                : selectedUserCarInfo?.year
            }
            onChange={(year) => handleSelectYear(year)}
          >
            {grDates.map((year, index) => {
              return (
                <Option key={index} value={year}>
                  {year}
                </Option>
              );
            })}
          </Select>
        </div>
      </div>
    </div>
  );
};

export default SelectNewCar;
